import {useAppSelector} from '../store_hooks';

// NOTE: `${decimalSeparator}${thousandsSeparator}`
export function useSeparators(): string {
  const currentLocale = useAppSelector((state) => state.i18n.currentLocale);
  return {
    cs: ', ',
    de: ', ',
    en: '.,',
    sk: ', ',
  }[currentLocale];
}
